<template>
<div v-if="false"></div>
</template>
<script>
import { POINT_MARKER_ICON_CONFIG, COLORS } from './settings/mapSettings'

export default {
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    marker: {
      type: Object,
      required: true
    }
  },

  mounted () {
    const MARKER_LABEL = {
      color: COLORS.MARKER_TEXT,
      fontSize: '13px',
      fontWeight: 'bold',
      text: String(this.marker.duration)
    }
    // eslint-disable-next-line
    const marker = new this.google.maps.Marker({
      position: this.marker.position,
      map: this.map,
      label: MARKER_LABEL,
      icon: POINT_MARKER_ICON_CONFIG,
      title: `${String(this.marker.order)}: ${String(this.marker.name)} (Days: ${this.marker.startday})`
    })
  }
}
</script>
